
import { SeriesCard } from "../../common/SeriesCard.js";
import { locale } from "../../../services/LocaleService.js";

export const SearchResultsGrid = (results, query) => {
    const section = document.createElement('section');
    section.className = "animate-fade-in";

    // Header logic...
    const header = document.createElement('div');
    header.className = "flex items-center justify-between mb-4 mt-2 px-1 md:px-0";
    header.innerHTML = `
        <div class="flex items-center gap-2">
            <h2 class="text-lg font-bold text-gray-900">${locale.t('main.search_results', { query })}</h2>
            <span class="text-sm text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">${results.length}</span>
        </div>
    `;
    section.appendChild(header);

    const grid = document.createElement('div');
    grid.className = "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 px-1 md:px-0";

    if (results.length === 0) {
        grid.className = "flex flex-col items-center justify-center py-20 text-center";
        grid.innerHTML = `
            <div class="text-4xl mb-4">😢</div>
            <p class="text-gray-500 font-medium">${locale.t('main.search_no_results')}</p>
            <p class="text-xs text-gray-400 mt-1">${locale.t('main.search_try_other')}</p>
        `;
        section.appendChild(grid);
        return section;
    }

    // [New Logic] Pre-calculate Active Events map here if we want instant synchronous render,
    // BUT 'home.js' will now pass 'marketingData' via 'optimization', 
    // OR we can rely on internal async fetch here?
    // Current plan says: "Phase 3: Data Integration in home.js".
    // For now, let's keep SearchResultsGrid generic. 
    // If 'home.js' injects marketing data into 'results' array before calling this, it's best.
    // If not, we might lose event borders momentarily until Phase 3 is done. 
    // *Strategy*: We will rely on Phase 3 to inject marketing props into the 'series' object 
    // passed to this function. 
    // OR: We can fetch here? No, 'SeriesCard' expects 'options.marketing'.
    // Let's assume 'results' items might have '_marketing' attached later, or we pass it.

    // For now, just generic render. The 'home.js' refactor will handle data merging.

    results.forEach(series => {
        const card = SeriesCard(series, {
            showType: true,
            overlayStats: true, // Show stats in grid
            marketing: series._marketing // Future-proofing for Phase 3
        });

        // No extra layout classes needed, grid handles sizing.
        // But SeriesCard has 'w-full' implicit? No, it's block.

        grid.appendChild(card);
    });

    section.appendChild(grid);
    return section;
};
